import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeviceCategory } from '@sky/util-models';

@Component({
  selector: 'sky-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss'],
})
export class DeviceDetailComponent {
  deviceCategoryEnum = DeviceCategory;
  @Input() deviceCategory = '';
  @Input() deviceId: string | undefined = undefined;
  // this work around will be removed next release
  @Input() deviceName: any = '';
  @Input() numberOfDevices = 0;

  @Output() removeDevice: EventEmitter<string> = new EventEmitter();

  handleRemoveDevice() {
    if (this.deviceId) {
      this.removeDevice.emit(this.deviceId);
    }
  }

  get isTelevision(): boolean {
    return this.deviceCategory === DeviceCategory.Television;
  }
}
